import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import Box from "@mui/material/Box";

export const StyledTable = styled(Table)(({ theme }) => ({
  width: "100%",
  borderCollapse: "collapse",
  "& td, & th": {
    border: "1px solid #ddd",
    padding: "8px",
    fontSize: "0.875rem",
    textAlign: "start",
    whiteSpace: "nowrap",
  },
  "& tr:nth-of-type(even)": {
    backgroundColor: "#f9f9f9",
  },
  "& tr:hover": {
    backgroundColor: "#f1f1f1",
  },
  "& th": {
    backgroundColor: "rgb(234, 245, 238) !important",
    fontWeight: 600,
  },
}));

export const TableWrapper = ({ children }) => (
  <Box sx={{ overflowX: "auto" }}>{children}</Box>
);
